import React, { useRef, useState } from 'react';
import AppHeaderMenu from './menu/index.js';
import AppHeaderSubMenu from './subMenu/index.js';

// This component handles way complex management of hovering different elements
// to keep opened state in between 2 hovers (Menu button and sub-menu area)
// Uses simple setTimeout to give js time to realize we hovered a different zone, then checks is anything is hovered
// if not - we hide the menu

const AppHeaderBottomBlock = ({ className, ...props }) => {
  const items = props?.fields?.items[0]?.fields?.items || [];
  const [activeItemIndex, setActiveItemIndex] = useState(-1);
  const areaHovered = useRef(false);
  const itemHovered = useRef(false);

  const handleItemHover = (itemIndex) => {
    itemHovered.current = true;
    setActiveItemIndex(itemIndex);
  };

  const handleItemBlur = () => {
    itemHovered.current = false;
    setTimeout(() => {
      if (!areaHovered.current && !itemHovered.current) {
        setActiveItemIndex(-1);
      }
    }, 50);
  };

  const handleAreaHover = () => {
    areaHovered.current = true;
  };

  const handleAreaBlur = () => {
    areaHovered.current = false;
    setTimeout(() => {
      if (!itemHovered.current && !areaHovered.current) {
        setActiveItemIndex(-1);
      }
    }, 50);
  };

  return (
    <div className={className}>
      <AppHeaderMenu
        items={items}
        activeItemIndex={activeItemIndex}
        handleItemHover={handleItemHover}
        handleItemBlur={handleItemBlur}
        i18n={props?.i18n}
      />
      <AppHeaderSubMenu
        items={items[activeItemIndex]?.fields?.items || []}
        onHover={handleAreaHover}
        onBlur={handleAreaBlur}
      />
    </div>
  );
};

export default AppHeaderBottomBlock;
